export default __webpack_public_path__ + "images/VK.5e7253f.png";